/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Organization } from '../model/organization';
import { OrganizationPagination } from '../model/organizationPagination';
import { RelationshipData } from '../model/relationshipData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { RelationshipServiceInterface }                            from './relationship.serviceInterface';


@Injectable()
export class RelationshipService implements RelationshipServiceInterface {

    protected basePath = 'https://api.keyclic.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve all Relationship resources.
     * 
     * @param x_keyclic_app 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param business_activity The identifier of the resource formatted as GUID string.
     * @param geo_coordinates One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param geo_point One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param search_alternateName 
     * @param search_billingEmailAddress 
     * @param search_description 
     * @param search_name 
     * @param search_notificationEmailAddress 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetRelationshipsByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_alternateName?: string, search_billingEmailAddress?: string, search_description?: string, search_name?: string, search_notificationEmailAddress?: string, observe?: 'body', reportProgress?: boolean): Observable<OrganizationPagination>;
    public cgetRelationshipsByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_alternateName?: string, search_billingEmailAddress?: string, search_description?: string, search_name?: string, search_notificationEmailAddress?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrganizationPagination>>;
    public cgetRelationshipsByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_alternateName?: string, search_billingEmailAddress?: string, search_description?: string, search_name?: string, search_notificationEmailAddress?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrganizationPagination>>;
    public cgetRelationshipsByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_alternateName?: string, search_billingEmailAddress?: string, search_description?: string, search_name?: string, search_notificationEmailAddress?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetRelationshipsByOrganization.');
        }
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling cgetRelationshipsByOrganization.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (business_activity !== undefined && business_activity !== null) {
            queryParameters = queryParameters.set('business_activity', <any>business_activity);
        }
        if (geo_coordinates !== undefined && geo_coordinates !== null) {
            queryParameters = queryParameters.set('geo_coordinates', <any>geo_coordinates);
        }
        if (geo_point !== undefined && geo_point !== null) {
            queryParameters = queryParameters.set('geo_point', <any>geo_point);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }
        if (search_alternateName !== undefined && search_alternateName !== null) {
            queryParameters = queryParameters.set('search[alternateName]', <any>search_alternateName);
        }
        if (search_billingEmailAddress !== undefined && search_billingEmailAddress !== null) {
            queryParameters = queryParameters.set('search[billingEmailAddress]', <any>search_billingEmailAddress);
        }
        if (search_description !== undefined && search_description !== null) {
            queryParameters = queryParameters.set('search[description]', <any>search_description);
        }
        if (search_name !== undefined && search_name !== null) {
            queryParameters = queryParameters.set('search[name]', <any>search_name);
        }
        if (search_notificationEmailAddress !== undefined && search_notificationEmailAddress !== null) {
            queryParameters = queryParameters.set('search[notificationEmailAddress]', <any>search_notificationEmailAddress);
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<OrganizationPagination>(`${this.basePath}/organizations/${encodeURIComponent(String(organization))}/relationships`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove one Relationship resource.
     * 
     * @param x_keyclic_app 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param relationship The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRelationshipByOrganizationAndRelationship(x_keyclic_app: string, organization: string, relationship: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Organization>;
    public deleteRelationshipByOrganizationAndRelationship(x_keyclic_app: string, organization: string, relationship: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Organization>>;
    public deleteRelationshipByOrganizationAndRelationship(x_keyclic_app: string, organization: string, relationship: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Organization>>;
    public deleteRelationshipByOrganizationAndRelationship(x_keyclic_app: string, organization: string, relationship: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling deleteRelationshipByOrganizationAndRelationship.');
        }
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling deleteRelationshipByOrganizationAndRelationship.');
        }
        if (relationship === null || relationship === undefined) {
            throw new Error('Required parameter relationship was null or undefined when calling deleteRelationshipByOrganizationAndRelationship.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.delete<Organization>(`${this.basePath}/organizations/${encodeURIComponent(String(organization))}/relationships/${encodeURIComponent(String(relationship))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create one Relationship resource.
     * 
     * @param x_keyclic_app 
     * @param RelationshipData 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postRelationshipByOrganization(x_keyclic_app: string, RelationshipData: RelationshipData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Organization>;
    public postRelationshipByOrganization(x_keyclic_app: string, RelationshipData: RelationshipData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Organization>>;
    public postRelationshipByOrganization(x_keyclic_app: string, RelationshipData: RelationshipData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Organization>>;
    public postRelationshipByOrganization(x_keyclic_app: string, RelationshipData: RelationshipData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling postRelationshipByOrganization.');
        }
        if (RelationshipData === null || RelationshipData === undefined) {
            throw new Error('Required parameter RelationshipData was null or undefined when calling postRelationshipByOrganization.');
        }
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling postRelationshipByOrganization.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Organization>(`${this.basePath}/organizations/${encodeURIComponent(String(organization))}/relationships`,
            RelationshipData,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
